import React from 'react';

import cn from 'classnames';

import { Flex } from '@shared/ui';

import cls from './UserHistoryTableHead.module.css';

interface UserHistoryTableHeadProps {
    classes?: string;
}

export const UserHistoryTableHead = ({ classes }: UserHistoryTableHeadProps) => (
    <div className={cn(cls.UserHistoryTableHead, [classes])}>
        <Flex justify="center" align="center" className={cls.tableHeadSection}>
            Время отправки
        </Flex>
        <Flex justify="center" align="center" className={cls.tableHeadSection}>
            Кол-во пользователей
        </Flex>
        <Flex justify="center" align="center" className={cls.tableHeadSection}>
            Прошли опрос
        </Flex>
        <Flex justify="center" align="center" className={cls.tableHeadSection}>
            Закрыли окно
        </Flex>
        <Flex justify="center" align="center" className={cls.tableHeadSection}>
            Тип отправки
        </Flex>
        <Flex justify="center" align="center" className={cls.tableHeadSection}>
            Источник
        </Flex>
    </div>
);
